import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  EventsControllerDtoEventFreeNftCreateRequest,
  EventsControllerDtoEventFreeNftDetailRequest, EventsControllerDtoEventFreeNftHistoryListRequest,
  EventsControllerDtoEventFreeNftListRequest, EventsControllerDtoEventFreeNftUpdateRequest,
  PerplayEventsApi,
} from '../../models/src';
import {
  freeNFTEventList,
  freeNFTEventResponse,
  setFreeNFTEventHistoryPagination,
  setFreeNFTEventListPagination,
  setTotalCount,
} from '../../actions/event/freeNFTEventActions';
import {
  FREE_NFT_EVENT_CREATE_REQUEST,
  FREE_NFT_EVENT_INFO_DETAILS,
  FREE_NFT_EVENT_INFO_DETAILS_REQUEST,
  FREE_NFT_EVENT_INFO_UPDATE_REQUEST,
  FREE_NFT_EVENT_LIST_REQUEST,
} from '../../constants/event/freeNFTEventConstants';
import BaseResponse from '../../models/src/model/BaseResponse';
import EventsControllerDtoEventFreeNftListResponse
  from '../../models/src/model/EventsControllerDtoEventFreeNftListResponse';
import EventsControllerDtoEventFreeNftDetailResponse
  from '../../models/src/model/EventsControllerDtoEventFreeNftDetailResponse';
import EventsControllerDtoEventFreeNftHistoryListResponse
  from '../../models/src/model/EventsControllerDtoEventFreeNftHistoryListResponse';

const api = new PerplayEventsApi(config.API_CLIENT);

function* freeNFTEventListRequestSaga(payload) {
  try {
    console.log('payload: ', payload);
    const requestData = new EventsControllerDtoEventFreeNftListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    const result = yield api.apiPerplayEventsEventFreeNftListPost(
      { eventsControllerDtoEventFreeNftListRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, EventsControllerDtoEventFreeNftListResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(freeNFTEventList(data.list));
      yield put(setTotalCount(data.totalCount));
      yield put(setFreeNFTEventListPagination(payload.page, data.totalCount));
    } else {
      yield put(
        freeNFTEventResponse(data.resultCode, '조회 실패 로그확인 필요.'),
      );
    }

    yield put(freeNFTEventResponse(null, null));
  } catch (e) {
    console.log(e);
  }
}

function* freeNFTEventCreateRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventFreeNftCreateRequest();
    requestData.mintingCode = payload.mintingCode;
    requestData.issuedCount = payload.issuedCount;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    const result = yield api.apiPerplayEventsEventFreeNftCreatePost(
      { eventsControllerDtoEventFreeNftCreateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    if (data.resultCode === 208) {
      throw Error(`중복된 코드 입니다.`);
    }
    if (data.resultCode !== 200) {
      throw Error(`${data.description}으로 등록 실패 로그확인 필요.`);
    }

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.log(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* freeNFTEventInfoDetailsRequestSaga(payload) {
  try {
    const requestDetailsData = new EventsControllerDtoEventFreeNftDetailRequest();
    requestDetailsData.freenftNo = payload.freenftNo;
    console.log('requestDetailsData: ', requestDetailsData);
    const detailsResult = yield api.apiPerplayEventsEventFreeNftDetailPost(
      { eventsControllerDtoEventFreeNftDetailRequest: requestDetailsData },
      () => {},
    );
    const detailsData = api.apiClient.deserialize(
      detailsResult,
      EventsControllerDtoEventFreeNftDetailResponse,
    );
    console.log('detailsData: ', detailsData);

    const requestHistoryData = new EventsControllerDtoEventFreeNftHistoryListRequest();
    requestHistoryData.freenftNo = payload.freenftNo;
    requestHistoryData.page = payload.page;
    requestHistoryData.pageLength = payload.pageLength;
    requestHistoryData.searchType = payload.searchType;
    requestHistoryData.searchString = payload.searchString;
    console.log('requestHistoryData: ', requestHistoryData);
    const historyResult = yield api.apiPerplayEventsEventFreeNftHistoryListPost(
      { eventsControllerDtoEventFreeNftHistoryListRequest: requestHistoryData },
      () => {},
    );
    const historyData = api.apiClient.deserialize(
      historyResult,
      EventsControllerDtoEventFreeNftHistoryListResponse,
    );
    console.log('historyData: ', historyData);

    // Update scheduleInfo and logInfo with data values
    yield put({
      type: FREE_NFT_EVENT_INFO_DETAILS,
      scheduleInfo: {
        freenftNo: detailsData.freenftNo,
        mintingCode: detailsData.mintingCode,
        issuedCount: detailsData.issuedCount,
        usedCount: detailsData.usedCount,
        beginAt: detailsData.beginAt,
        endAt: detailsData.endAt,
        createdAt: detailsData.createdAt,
      },
      logInfo: historyData.list,
    });

    yield put(setTotalCount(historyData.totalCount));
    yield put(
      setFreeNFTEventHistoryPagination(
        payload.page,
        historyData.totalCount,
        payload.searchType,
        payload.searchString,
      ),
    );
  } catch (e) {
    console.log(e);
  }
}

function* freeNFTEventInfoUpdateRequestSaga(payload) {
  try {
    const requestData = new EventsControllerDtoEventFreeNftUpdateRequest();
    requestData.freenftNo = payload.freenftNo;
    requestData.mintingCode = payload.mintingCode;
    requestData.issuedCount = payload.issuedCount;
    requestData.beginAt = payload.beginAt;
    requestData.endAt = payload.endAt;
    console.log(requestData);
    const result = yield api.apiPerplayEventsEventFreeNftUpdatePost(
      { eventsControllerDtoEventFreeNftUpdateRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);

    if (data.resultCode === 200) {
      yield put(freeNFTEventResponse(data.resultCode, '이벤트 업데이트 성공.'));
    } else {
      yield put(
        freeNFTEventResponse(
          data.resultCode,
          `${data.description}으로 업데이트 실패 로그확인 필요.`,
        ),
      );
    }
  } catch (e) {
    console.log(e);
  }
}

function* freeNFTEventRootSaga() {
  yield all([
    takeEvery(FREE_NFT_EVENT_LIST_REQUEST, freeNFTEventListRequestSaga),
    takeEvery(FREE_NFT_EVENT_CREATE_REQUEST, freeNFTEventCreateRequestSaga),
    takeEvery(FREE_NFT_EVENT_INFO_DETAILS_REQUEST, freeNFTEventInfoDetailsRequestSaga),
    takeEvery(FREE_NFT_EVENT_INFO_UPDATE_REQUEST, freeNFTEventInfoUpdateRequestSaga),
  ]);
}

const freeNFTEventSagas = [fork(freeNFTEventRootSaga)];

export default freeNFTEventSagas;
